module.exports = "/images/MT.png?35bc01ba216077376edb25f7a4404b2a";